import React, {useState, Fragment, useRef, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import {useForm} from '../Form/index';
import {Dialog, Transition} from '@headlessui/react';
import {ExclamationTriangleIcon} from '@heroicons/react/24/outline';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import {getProspects, getPaises, getRepresentantes} from '../../../pages/requests';
// import {MultiRangeSlider, initTE} from 'tw-elements';
import MultiRangeSlider from '../../MultiRangeSlider';
import HandshakeRoundedIcon from '@mui/icons-material/HandshakeRounded';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import ExitForm from '../../ExitFormModal';
import CreateIcon from '@mui/icons-material/Create';
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import SelectComponent from '../../Selects/SelectComponent';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import FiltrosProdutosVendidos from './FiltrosProdutosVendidos';
import FiltrosParqueEquipamentos from './FiltrosParqueEquipamentos';
import FiltrosContaCorrente from './FiltrosContaCorrente';
import FiltrosHistoricoInteracoes from './FiltrosHistoricoInteracoes';
import FiltrosHistoricoOportunidades from './FiltrosHistoricoOportunidades';
import FiltrosHistoricoPropostas from './FiltrosHistoricoPropostas';
import {useContext} from 'react';
import {Context} from '../../../Helpers/Auth';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';

function DrawerFilter({
    valorMax,
    setValorMax,
    valorMin,
    setValorMin,
    setShowForm,
    showForm,
    min,
    max,

    setProspectSelecionado,
    prospectSelecionado,

    setEditarProspect,
    editarProspect,

    setOnChangeForm,
    onChangeForm,

    setGuardar,

    setOpenTab,
    openTab,

    setNovaReuniaoVisita,

    filtroNome,
    setFiltroNome,
    filtroNif,
    setFiltroNif,
    filtroCidade,
    setFiltroCidade,
    filtroPais,
    setFiltroPais,
    filtroRepresentante,
    setFiltroRepresentante,
    paises,

    ///Filtros produtos vendidos
    filtroReferencia,
    setFiltroReferencia,
    filtroDesc,
    setFiltroDesc,
    filtroQuantidade,
    setFiltroQuantidade,
    filtroPreco,
    setFiltroPreco,
    filtroNumEncomenda,
    setFiltroNumEncomenda,
    formattedDateEnc,
    setFormattedDateEnc,
    dataPdf,
    setDataPdf,
    filtroDtEncomenda,
    setFiltroDtEncomenda,
    filtroPrecoTotal,
    setFiltroPrecoTotal,

    // FILTRO PARQUE DE EQUIPAMENTOS

    filtroNumEquipamento,
    setFiltroNumEquipamento,
    filtroNumSerie,
    setFiltroNumSerie,
    filtroArtigo,
    setFiltroArtigo,
    filtroMarca,
    setFiltroMarca,
    filtroNacionalInternacional,
    setFiltroNacionalInternacional,
    filtroTipo,
    setFiltroTipo,
    filtroModelo,
    setFiltroModelo,
    filtroVersao,
    setFiltroVersao,
    filtroEspecificacao,
    marcas,
    setMarcas,
    nacionaisInternacionais,
    setNacionaisInternacionais,
    tipos,
    setTipos,
    modelos,
    setModelos,
    versoes,
    setVersoes,
    setFiltroEspecificacao,
    filtroDescParque,
    setFiltroDescParque,

    // conta corrente
    filtroSociedade,
    setFiltroSociedade,
    filtroEstab,
    setFiltroEstab,
    filtroEndereco,
    setFiltroEndereco,
    filtroDtFatura,
    setFiltroDtFatura,
    filtroDtVencimento,
    setFiltroDtVencimento,
    filtroRep,
    setFiltroRep,
    filtroValor,
    setFiltroValor,
    filtroValorPendente,
    setFiltroValorPendente,
    filtroNumDoc,
    setFiltroNumDoc,
    filtroDivisa,
    setFiltroDivisa,
    representantes,
    setRepresentantes,
    estabelecimentos,
    setEstabelecimentos,
    divisas,
    setDivisas,

    // historico visitas
    filtroCodigo,
    setFiltroCodigo,
    filtroEstabHistorico,
    setFiltroEstabHistorico,
    filtroCategoria,
    setFiltroCategoria,
    filtroDtInicio,
    setFiltroDtInicio,
    filtroDtFim,
    setFiltroDtFim,
    filtroRepHistorico,
    setFiltroRepHistorico,
    categorias,
    setCategorias,
    //historico de oportunidades
    filtroNomeHistorico,
    setFiltroNomeHistorico,
    filtroEtapa,
    setFiltroEtapa,
    filtroRepHisOp,
    setFiltroRepHisOp,
    filtroEmpresa,
    setFiltroEmpresa,
    filtroDt,
    setFiltroDt,
    filtroValorHistorico,
    setFiltroValorHistorico,
    etapasHistoricoOp,
    setEtapasHistoricoOp,
    representantesHistoricoOp,
    setRepresentantesHistoricoOp,
    // historico proposta
    filtroId,
    setFiltroId,
    filtroTipoProposta,
    setFiltroTipoProposta,
    filtroDtProposta,
    setFiltroDtProposta,
    filtroCliente,
    setFiltroCliente,
    filtroEstado,
    setFiltroEstado,
    filtroLinhas,
    setFiltroLinhas,
    formattedDate,
    setFormattedDate,
    ids,
    setIds,
    tiposProposta,
    setTiposProposta,
    estados,
    setEstados,
    setNovoNegocio,
    download,
    setDownload,
}) {
    const {t} = useTranslation();
    //--------
    // const [valorMin, setValorMin] = useState(0);
    // const [valorMax, setValorMax] = useState(0);
    // const min = 0;
    // const max = 100;

    const handleRangeChangeMin = e => {
        setValorMin(e.target.value);
    };
    const handleRangeChangeMax = e => {
        setValorMax(e.target.value);
    };

    //--------
    const [openExit, setOpenExit] = useState(false);
    // const [paises, setPaises] = useState([]);
    const [isMobile, setIsMobile] = useState(false);

    const [state, setState] = useState({
        right: false,
    });
    const {isCard, setIsCard, openCards, setOpenCards} = useContext(Context);

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const handleResize = () => {
        setIsMobile(window.innerWidth < 900);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleDrawer = (anchor, open) => event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({...state, [anchor]: open});
    };

    const closeDrawer = anchor => {
        setState({...state, [anchor]: false});
    };

    useEffect(() => {
        // getPaises(lang).then(res => {
        //     setPaises(res.data.paises);
        // });

        // getRepresentantes(lang).then(res => {
        //     setRepresentantes(res.data.representantes);
        // });
    }, []);

    function showButton(params) {
        if (filtroNome != '' || filtroNif != '' || filtroCidade != '' || filtroRepresentante != null || filtroPais != null) {
            return true;
        } else {
            return false;
        }
    }

    function limparFiltros(params) {
        setFiltroNome('');
        setFiltroNif('');
        setFiltroCidade('');
        setFiltroRepresentante(0);
        setFiltroPais(0);
    }

    const list = anchor => (
        <ClickAwayListener onClickAway={() => closeDrawer(anchor)}>
            <Box sx={{width: 320}} role="presentation" className="h-full  bg-white w-80 dark:bg-gray-800">
                <h5 id="drawer-label" className="inline-flex p-4 items-center mb-6 text-base font-semibold text-blue-600 uppercase dark:text-blue-600">
                    <FilterAltIcon className="mr-2" />
                    {t('filtros')}
                </h5>
                <button
                    type="button"
                    data-drawer-hide="drawer-contact"
                    aria-controls="drawer-contact"
                    onClick={() => {
                        closeDrawer(anchor);
                    }}
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-blue-600 rounded-[8px] text-sm w-8 h-8 absolute top-2.5 right-2.5 inline-flex items-center justify-center dark:hover:bg-blue-600 dark:hover:text-white">
                    <CloseIcon />
                    <span className="sr-only">Close menu</span>
                </button>
                <div className="mb-6 p-4 bg-white  dark:bg-gray-800">
                    {!showForm && openTab == 10 && (
                        <div>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                    <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                    </svg>
                                </div>
                                <input
                                    type="search"
                                    id="default-search"
                                    value={filtroNome}
                                    className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder={t('filtroNome')}
                                    onChange={e => {
                                        setFiltroNome(e.target.value);
                                    }}
                                />
                            </div>
                            <div className="relative mt-4">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                    <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                    </svg>
                                </div>
                                <input
                                    type="search"
                                    id="default-search"
                                    value={filtroNif}
                                    className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder={t('filtroNif')}
                                    onChange={e => {
                                        setFiltroNif(e.target.value);
                                    }}
                                />
                            </div>
                            <div className="relative mt-4">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                    <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                    </svg>
                                </div>
                                <input
                                    type="search"
                                    id="default-search"
                                    value={filtroCidade}
                                    className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder={t('filtroCidade')}
                                    onChange={e => {
                                        setFiltroCidade(e.target.value);
                                    }}
                                />
                            </div>
                            <div className=" mt-4">
                                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('representante')}
                                </label>
                                <SelectComponent
                                    options={representantes}
                                    value={filtroRepresentante}
                                    onChange={e => {
                                        setFiltroRepresentante(e);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                    placeholder={t('filtroRep')}
                                />
                            </div>
                            <div className=" mt-4">
                                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('pais')}
                                </label>
                                <SelectComponent
                                    options={paises}
                                    value={filtroPais}
                                    onChange={e => {
                                        setFiltroPais(e);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                    placeholder={t('filtroPais')}
                                />
                            </div>
                            {showButton() && (
                                <div className="flex flex-row justify-end mt-4">
                                    <button
                                        type="button"
                                        onClick={() => limparFiltros()}
                                        className="flex items-center font-semibold text-sm justify-center text-white bg-red-700 rounded-[8px] py-1 px-2 hover:bg-red-800 dark:bg-red-600 dark:hover:bg-red-700 focus:ring-4 focus:ring-red-300 focus:outline-none dark:focus:ring-red-800">
                                        {t('limparFiltros')} <CloseRoundedIcon />
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                    {!showForm && openTab == 11 && (
                        <div>
                            <div className="mt-4 mb-8">
                                <span className="text-gray-600 text-lg font-semibold dark:text-gray-400">{t('valorMin')}:</span>
                                <div className="relative">
                                    <label htmlFor="price-range-input" className="sr-only">
                                        Default range
                                    </label>

                                    <input
                                        id="price-range-input"
                                        type="range"
                                        value={valorMin}
                                        min={min}
                                        max={valorMax}
                                        onChange={e => {
                                            handleRangeChangeMin(e);
                                        }}
                                        style={{
                                            '--thumb-color': '#1c64f2',
                                        }}
                                        className="w-11/12 h-2 bg-gray-300 ml-5 rounded-[8px] appearance-none cursor-pointer dark:bg-gray-700"
                                        // disabled={questionarioSelecionado.validado || !permissao.modificar}
                                    />

                                    <style>
                                        {`
                                                                #price-range-input::-webkit-slider-thumb {
                                                                    background-color: var(--thumb-color);
                                                                }
                                                            `}
                                    </style>
                                    <span className="text-sm text-gray-500 dark:text-gray-400 absolute start-4 -bottom-6">0</span>
                                    <span className="text-lg text-gray-500 dark:text-gray-200 font-semibold absolute ml-2 start-48 -translate-x-1/2 rtl:translate-x-1/2 -bottom-6">{valorMin}</span>
                                    <span className="text-sm text-gray-500 dark:text-gray-400 absolute  start-[280px] -bottom-10 sm:-bottom-6">{valorMax}</span>
                                </div>
                            </div>
                            <div className="mt-4 mb-8">
                                <span className="text-gray-600 text-lg font-semibold dark:text-gray-400">{t('valorMax')}:</span>
                                <div className="relative">
                                    <label htmlFor="price-range-input" className="sr-only">
                                        Default range
                                    </label>

                                    <input
                                        id="price-range-input"
                                        type="range"
                                        value={valorMin == 0 ? max : valorMax}
                                        min={valorMin}
                                        max={max}
                                        onChange={e => {
                                            handleRangeChangeMax(e);
                                        }}
                                        style={{
                                            '--thumb-color': '#1c64f2',
                                        }}
                                        className="w-11/12 h-2 bg-gray-300 ml-5 rounded-[8px] appearance-none cursor-pointer dark:bg-gray-700"
                                        // disabled={questionarioSelecionado.validado || !permissao.modificar}
                                    />

                                    <style>
                                        {`
                                                                #price-range-input::-webkit-slider-thumb {
                                                                    background-color: var(--thumb-color);
                                                                }
                                                            `}
                                    </style>
                                    <span className="text-sm text-gray-500 dark:text-gray-400 absolute start-4 -bottom-6">{valorMin}</span>
                                    <span className="text-lg text-gray-500 dark:text-gray-200 font-semibold absolute ml-2 start-48 -translate-x-1/2 rtl:translate-x-1/2 -bottom-6">
                                        {valorMin == 0 ? max : valorMax}
                                    </span>
                                    <span className="text-sm text-gray-500 dark:text-gray-400 absolute  start-[280px] -bottom-10 sm:-bottom-6">{valorMax}</span>
                                </div>
                            </div>
                        </div>
                    )}
                    {openTab == 4 && (
                        <FiltrosProdutosVendidos
                            info={{
                                filtroReferencia,
                                setFiltroReferencia,
                                filtroDesc,
                                setFiltroDesc,
                                filtroQuantidade,
                                setFiltroQuantidade,
                                filtroPreco,
                                setFiltroPreco,
                                filtroNumEncomenda,
                                setFiltroNumEncomenda,
                                formattedDateEnc,
                                setFormattedDateEnc,
                                dataPdf,
                                setDataPdf,
                                filtroDtEncomenda,
                                setFiltroDtEncomenda,
                                filtroPrecoTotal,
                                setFiltroPrecoTotal,
                            }}
                        />
                    )}
                    {openTab == 5 && (
                        <FiltrosParqueEquipamentos
                            info={{
                                filtroNumEquipamento,
                                setFiltroNumEquipamento,
                                filtroNumSerie,
                                setFiltroNumSerie,
                                filtroArtigo,
                                setFiltroArtigo,
                                filtroMarca,
                                setFiltroMarca,
                                filtroNacionalInternacional,
                                setFiltroNacionalInternacional,
                                filtroTipo,
                                setFiltroTipo,
                                filtroModelo,
                                setFiltroModelo,
                                filtroVersao,
                                setFiltroVersao,
                                filtroEspecificacao,
                                marcas,
                                setMarcas,
                                nacionaisInternacionais,
                                setNacionaisInternacionais,
                                tipos,
                                setTipos,
                                modelos,
                                setModelos,
                                versoes,
                                setVersoes,
                                setFiltroEspecificacao,
                                filtroDescParque,
                                setFiltroDescParque,
                            }}
                        />
                    )}
                    {openTab == 6 && (
                        <FiltrosContaCorrente
                            info={{
                                filtroSociedade,
                                setFiltroSociedade,
                                filtroEstab,
                                setFiltroEstab,
                                filtroEndereco,
                                setFiltroEndereco,
                                filtroDtFatura,
                                setFiltroDtFatura,
                                filtroDtVencimento,
                                setFiltroDtVencimento,
                                filtroRep,
                                setFiltroRep,
                                filtroValor,
                                setFiltroValor,
                                filtroValorPendente,
                                setFiltroValorPendente,
                                filtroNumDoc,
                                setFiltroNumDoc,
                                filtroDivisa,
                                setFiltroDivisa,
                                representantes,
                                setRepresentantes,
                                estabelecimentos,
                                setEstabelecimentos,
                                divisas,
                                setDivisas,
                            }}
                        />
                    )}
                    {openTab == 7 && (
                        <FiltrosHistoricoInteracoes
                            info={{
                                filtroCodigo,
                                setFiltroCodigo,
                                filtroEstabHistorico,
                                setFiltroEstabHistorico,
                                filtroCategoria,
                                setFiltroCategoria,
                                filtroDtInicio,
                                setFiltroDtInicio,
                                filtroDtFim,
                                setFiltroDtFim,
                                filtroRepHistorico,
                                setFiltroRepHistorico,
                                categorias,
                                setCategorias,
                                estabelecimentos,
                                representantes,
                            }}
                        />
                    )}
                    {openTab == 8 && (
                        <FiltrosHistoricoOportunidades
                            info={
                                //historico de oportunidades
                                {
                                    filtroNomeHistorico,
                                    setFiltroNomeHistorico,
                                    filtroEtapa,
                                    setFiltroEtapa,
                                    filtroRepHisOp,
                                    setFiltroRepHisOp,
                                    filtroEmpresa,
                                    setFiltroEmpresa,
                                    filtroDt,
                                    setFiltroDt,
                                    filtroValorHistorico,
                                    setFiltroValorHistorico,
                                    etapasHistoricoOp,
                                    setEtapasHistoricoOp,
                                    representantesHistoricoOp,
                                    setRepresentantesHistoricoOp,
                                }
                            }
                        />
                    )}
                    {openTab == 9 && (
                        <FiltrosHistoricoPropostas
                            info={{
                                filtroId,
                                setFiltroId,
                                filtroTipoProposta,
                                setFiltroTipoProposta,
                                filtroDtProposta,
                                setFiltroDtProposta,
                                filtroCliente,
                                setFiltroCliente,
                                filtroEstado,
                                setFiltroEstado,
                                filtroLinhas,
                                setFiltroLinhas,
                                formattedDate,
                                setFormattedDate,
                                ids,
                                setIds,
                                tiposProposta,
                                setTiposProposta,
                                estados,
                                setEstados,
                            }}
                        />
                    )}
                </div>
            </Box>
        </ClickAwayListener>
    );

    return (
        <>
            <div className="flex flex-row items-center">
                <>
                    {' '}
                    {!isMobile && (
                        <div className="flex items-center mr-3">
                            <label className="relative inline-flex items-center cursor-pointer">
                                <input type="checkbox" checked={isCard} onChange={() => setIsCard(!isCard)} className="sr-only peer" />
                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('modoCard')}</span>
                            </label>
                        </div>
                    )}
                    {isCard && (
                        <div className="flex items-center mr-3">
                            <label className="relative inline-flex items-center cursor-pointer">
                                <input type="checkbox" checked={openCards} onChange={() => setOpenCards(!openCards)} className="sr-only peer" />
                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('abrirCards')}</span>
                            </label>
                        </div>
                    )}
                </>

                <div className={showForm ? 'inline-flex rounded-[8px] shadow-sm' : 'inline-flex mb-4 rounded-[8px] shadow-sm'} role="group">
                    {/* Botão para voltar */}
                    {showForm && (
                        <button
                            type="button"
                            title={t('voltar')}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10 dark:bg-blue-700 text-blue-700 focus:ring-blue-700 focus:ring-2 rounded-l-[8px] dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white`}
                            onClick={() => {
                                if (onChangeForm) {
                                    setOpenExit(true);
                                } else {
                                    setShowForm(false);
                                    setEditarProspect(false);
                                    setOpenTab(10);
                                    setProspectSelecionado(null);
                                }
                            }}>
                            <KeyboardBackspaceRoundedIcon />
                        </button>
                    )}

                    {/* Botão de filtros */}
                    {/* {!showForm && ( */}
                    <button
                        title={t('filtros')}
                        type="button"
                        onClick={toggleDrawer('right', true)}
                        className={`inline-flex items-center px-4 py-2  text-sm font-medium text-gray-500 bg-white border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white ${
                            !showForm && 'rounded-l-[8px]'
                        }`}>
                        <FilterAltIcon />
                    </button>
                    {/* )} */}
                    {/* Botao do Download file */}
                    {!showForm && (
                        <button
                            title={t('Download')}
                            type="button"
                            onClick={() => {
                                setDownload(true);
                            }}
                            className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white">
                            <FileDownloadRoundedIcon />
                        </button>
                    )}
                    {/* Botão para criar uma nova conta */}
                    {!showForm && (
                        <button
                            type="button"
                            title={t('criarConta')}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10 dark:bg-gray-700 text-gray-500 rounded-r-[8px] dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white`}
                            onClick={() => {
                                setShowForm(true);
                                setEditarProspect(true);
                                setOpenTab(1);
                            }}>
                            <NoteAddIcon />
                        </button>
                    )}

                    {/* Botão de criar nova Reuniao/visita/interação */}
                    {showForm && prospectSelecionado && (
                        <button
                            type="submit"
                            title={t('criarReuniaoVisita')}
                            onClick={() => {
                                setNovaReuniaoVisita(true);
                            }}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border  border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white `}>
                            {<CalendarTodayRoundedIcon />}
                        </button>
                    )}
                    {/* Botão de criar novo negocio */}
                    {showForm && prospectSelecionado && (
                        <button
                            type="submit"
                            title={t('criarNegocio')}
                            onClick={() => {
                                setNovoNegocio(true);
                            }}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border  border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white `}>
                            {<HandshakeRoundedIcon />}
                        </button>
                    )}

                    {/* botão para guardar */}
                    {showForm && editarProspect && (
                        <button
                            title={t('salvarMudancas')}
                            type="submit"
                            onClick={() => {
                                setGuardar(true);
                            }}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border rounded-r-[8px] border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white`}>
                            {<SaveIcon />}
                        </button>
                    )}

                    {/* botão para ativar a edição */}
                    {showForm && !editarProspect && (
                        <button
                            title={t('editar')}
                            type="submit"
                            onClick={() => {
                                setEditarProspect(true);
                            }}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border rounded-r-[8px] border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white`}>
                            {<CreateIcon />}
                        </button>
                    )}
                </div>
            </div>
            <Drawer anchor="right" open={state['right']} onClose={toggleDrawer('right', false)}>
                {list('right')}
            </Drawer>
            {openExit && (
                <ExitForm
                    cancelar={() => setOpenExit(false)}
                    back={() => {
                        setOpenExit(false);
                        setOpenTab(10);
                        setShowForm(false);
                        setOnChangeForm(false);
                        setProspectSelecionado(null);
                    }}
                />
            )}
        </>
    );
}

export default DrawerFilter;
